export const POSTCODE_REGEX =
  /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i;

export const validatePostcode = (value: string) =>
  new RegExp(POSTCODE_REGEX).test(value);
